// CategorySelector.js
import React from "react";
import "./CategorySelector.css";

const categories = [
  { value: "wellness", label: "Wellness" },
  { value: "treatments", label: "Treatments" },
  { value: "announcements", label: "Announcements" },
  { value: "tips", label: "Tips & Advice" },
  { value: "other", label: "Other" },
];

const CategorySelector = ({ selected, onChange }) => {
  return (
    <div className="category-selector">
      <select value={selected} onChange={(e) => onChange(e.target.value)}>
        {categories.map((category) => (
          <option key={category.value} value={category.value}>
            {category.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CategorySelector;
